/* ASYCO 2 AI - "Vistos recientemente" (asset del tema, cargado desde theme.liquid).
   Graba cada producto visto en localStorage (site-wide) y rinde un carrusel en
   #asyco-recent-root del PDP. Reemplaza la version inline (no fiable en este tema/SPA).
   Solo lee fuentes reales (/products/<handle>.js); muestra solo productos disponibles. */
(function () {
  'use strict';
  var KEY = 'asyco_recent', MAX = 12, SHOW = 8;

  function curHandle() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; }
  function readHist() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function record(h) { if (!h) return; try { var a = readHist().filter(function (x) { return x && x !== h; }); a.unshift(h); localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); }
  function imgU(u) { if (!u) return ''; if (u.slice(0, 2) === '//') u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=260'; }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function setupCarousel(root) {
    var row = root.querySelector('.asyco-rv__row');
    var prev = root.querySelector('.asyco-rv-arrow--prev'), next = root.querySelector('.asyco-rv-arrow--next');
    if (!row || !prev || !next) return;
    function maxSL() { return row.scrollWidth - row.clientWidth; }
    function step() { return Math.max(row.clientWidth * 0.8, 200); }
    function upd() { prev.disabled = (row.scrollLeft <= 4); next.disabled = (row.scrollLeft >= maxSL() - 4); }
    function go(t) { row.scrollLeft = Math.max(0, Math.min(t, maxSL())); upd(); }
    prev.addEventListener('click', function () { go(row.scrollLeft - step()); });
    next.addEventListener('click', function () { go(row.scrollLeft + step()); });
    row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  function render() {
    var root = document.getElementById('asyco-recent-root'); if (!root) return;
    var cur = curHandle();
    var hist = readHist().filter(function (h) { return h && h !== cur; });
    if (hist.length < 2) return;
    var sig = (cur || '') + '|' + hist.slice(0, SHOW).join(',');
    if (root.getAttribute('data-rv') === sig) return; // ya rendido identico, evita reflujos
    Promise.all(hist.slice(0, 10).map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var out = ps.filter(function (p) { return p && p.available && p.handle !== cur; }).slice(0, SHOW);
      if (out.length < 2) return;
      root.innerHTML =
        '<div class="asyco-rv-wrap">' +
        '<button type="button" class="asyco-rv-arrow asyco-rv-arrow--prev" aria-label="Anterior">&#8249;</button>' +
        '<div class="asyco-rv__row">' +
        out.map(function (p) {
          var href = '/products/' + p.handle;
          return '<a class="asyco-rvcard" href="' + href + '"><img class="asyco-rvcard__img" loading="lazy" src="' + imgU(p.featured_image) + '" alt="' + esc(p.title) + '"><span class="asyco-rvcard__t">' + esc(p.title) + '</span></a>';
        }).join('') +
        '</div>' +
        '<button type="button" class="asyco-rv-arrow asyco-rv-arrow--next" aria-label="Siguiente">&#8250;</button>' +
        '</div>';
      root.setAttribute('data-rv', sig);
      var sec = document.getElementById('asyco-rv-section'); if (sec) sec.style.display = '';
      setupCarousel(root);
    });
  }

  function run() { record(curHandle()); render(); }

  function boot() {
    run();
    ['pageshow', 'popstate'].forEach(function (ev) { window.addEventListener(ev, function () { setTimeout(run, 60); }); });
    document.addEventListener('shopify:section:load', function () { setTimeout(run, 60); });
    // SPA / view-transition del tema: detectar cambio de path SIN observar todo el DOM
    // (el MutationObserver sobre documentElement subtree disparaba en CADA mutacion del sitio).
    var lastPath = location.pathname;
    function onNav() { if (location.pathname !== lastPath) { lastPath = location.pathname; setTimeout(run, 120); } }
    // (a) Navigation API (Chromium): cubre las navegaciones same-document del tema, sin parchear history
    // (parchear history.pushState no es fiable: los modulos del tema lo re-envuelven despues).
    try { if (window.navigation && navigation.addEventListener) navigation.addEventListener('navigate', function () { setTimeout(onNav, 60); }); } catch (e) {}
    // (b) Fallback barato (Safari / sin Navigation API): al hacer clic en un link de producto, re-evaluar tras la transicion.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (a) { setTimeout(onNav, 250); setTimeout(onNav, 750); }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
